'use client';

import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/shared/libs/i18n';

interface I18nProviderProps {
  children: React.ReactNode;
}

export default function I18nProvider({ children }: I18nProviderProps) {
  useEffect(() => {
    // Initialiser i18n côté client
    if (!i18n.isInitialized) {
      i18n.init();
    }
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
